import axios, { AxiosInstance, AxiosError } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Callback que se ejecutará cuando se detecte un error 401
let onUnauthorizedCallback: (() => void) | null = null;

/**
 * Configura el callback que se ejecutará cuando se detecte un error 401 (token expirado)
 */
export const setUnauthorizedCallback = (callback: () => void) => {
  onUnauthorizedCallback = callback;
};

/**
 * Crea una instancia de Axios con interceptores configurados
 */
export const createApiInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Interceptor de respuestas para manejar errores 401
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      // Si el error es 401 (Unauthorized), ejecutar el callback de logout
      if (error.response?.status === 401 && onUnauthorizedCallback) {
        console.warn('Token expirado o inválido. Cerrando sesión...');
        onUnauthorizedCallback();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export { API_BASE_URL };
